import defaultAvatar from "@/static/img/defaultAvatar.jpg";

// Profile images use a filename or the legacy "default" sentinel.
export function userAvatar(image) {
  if (typeof image !== "string" || ["", ".", "..", "default", "null", "undefined"].includes(image.trim().toLowerCase())) {
    return defaultAvatar;
  }
  try {
    return "/be/images/userphotos/" + encodeURIComponent(image);
  } catch {
    return defaultAvatar;
  }
}
